import React, { memo, useCallback, useEffect, useRef, useState } from 'react';

import { CONTENT_TYPE } from '../../config';
import { FlexDiv, GenericDiv, GenericP, GenericSpan } from 'commonStyles';
import { DescriptionWrapper, Description, ContentHeading, ContentTypeWrap } from './ContentStyle';
import Content from './Content';
import Curl from '../Curl/Curl';
import Listing from '../Listing/Listing';
import Tabular from '../Tabular/Tabular';
import Tags from '../Tags/Tags';
import Table from '../Table/Table';
import { IntegrationSprite } from '../../../../Style';

import CopyData from '../../../../common/copyData/copyData';

const ContentTypes = ({ data = {} }) => {
	const { key, type, heading, styles = {}, description, content = [], listing, tabList, tags, tableData, icon, pageRedirections, $width, columns = '1', stickyId, isCopy } = data;
	const contentRef = useRef();
	const wrapperRef = useRef();

	const [positionstyles, setPositionStyles] = useState({ zIndex: styles.zIndex });
	const [containerstyles, setContainerStyles] = useState({ });
	const initialstyles = ({ zIndex: styles.zIndex });

	const renderHeading = ($width) => {
		const { text, styles = {}, subText } = heading || {};
		const { font = 'h4', fontSize, margin = '0 0 20px', headingType } = styles;

		if (heading) {
			const type = headingType || font;
			return (
				<GenericDiv margin={margin} $width={styles.$width || $width}>
					<FlexDiv justify='space-between' align='center'>
						<ContentHeading $width={isCopy ? 'auto' : '100%'} font_size={fontSize} as={type} dangerouslySetInnerHTML={{ __html: text || '' }} />
						{isCopy && <CopyData wrapper={wrapperRef} data={data} />}
					</FlexDiv>

					{subText && <GenericP top_M='10' dangerouslySetInnerHTML={{ __html: subText }} />}
				</GenericDiv>
			);
		}
		return null;
	};

	useEffect(()=>{
		if (stickyId) {
			initialstyles.top = contentRef.current.getBoundingClientRect().top + window.scrollY;
			initialstyles.left = contentRef.current.getBoundingClientRect().left;
			initialstyles.height = contentRef.current.offsetHeight + 'px';
			initialstyles.zIndex = styles.zIndex;
			initialstyles.position = 'relative';
		}
	}, []);

	const scrollHandler = ()=>{
		if (initialstyles.top < window.scrollY + 120) {
			setPositionStyles({
				position: 'fixed',
				top: '120px',
				left: initialstyles.left,
				zIndex: styles.zIndex
			});
			setContainerStyles({
				height: initialstyles.height
			});
		} else {
			setPositionStyles({ zIndex: styles.zIndex });
		}
	};

	useEffect(() => {
		stickyId && window.addEventListener('scroll', scrollHandler);

		return () => {
			stickyId && window.removeEventListener('scroll', scrollHandler);
		};
	}, [stickyId]);

	const renderTypes = (contentRef) => {
		switch (type) {
			case CONTENT_TYPE.PARAGRAPH:
				return (
					<DescriptionWrapper ref={contentRef} color={styles.color || '#000'} padd={styles.background ? '8px 10px' : '0'} justify='flex-start' align='center'>
						{icon && <GenericSpan right_M='12'><IntegrationSprite icon={icon} /></GenericSpan>}
						<Description
							as='p'
							fsize={styles.fontSize || '14'}
							f_weight={styles.fontWeight}
							$width='inherit'
							justify='flex-start'
							line_height={styles.line_height}
							margin={styles.margin}
							dangerouslySetInnerHTML={{ __html: description }}
						/>
					</DescriptionWrapper>
				);
			case CONTENT_TYPE.LISTING:
				return (
					<Listing ref={contentRef} listing={listing} styles={styles} />
				);
			case CONTENT_TYPE.IMAGE:
				break;
			case CONTENT_TYPE.CURL:
			case CONTENT_TYPE.JSON:
				return <Curl ref={contentRef} data={data} type={type} />;
			case CONTENT_TYPE.TABLE:
				return <Table ref={contentRef} tableData={tableData} isCopy={isCopy && !heading} styles={styles} />;
			case CONTENT_TYPE.TABS:
				return <Tabular styles={styles} isCopy={isCopy} ref={contentRef} tabList={tabList} pageRedirections={pageRedirections} />;
			case CONTENT_TYPE.TAGS:
				return <Tags ref={contentRef} tags={tags} />;
			default:
				return <GenericSpan ref={contentRef} {...styles} dangerouslySetInnerHTML={{ __html: data }} />;
		}
	};
	const noOfCols = parseInt(columns);
	let contentData = [];

	if (content.length) {
		if (content[0].length) {
			contentData = content;
		} else {
			contentData[0] = content;
		}
	} else {
		contentData[0] = content;
	}

	const colWidth = 100 / noOfCols + '%';
	return (
		<FlexDiv justify={stickyId ? 'flex-end' : 'flex-start'} height={containerstyles.height} $width={styles.$width}>

			<ContentTypeWrap
				boxType={styles.boxType}
				$width={styles.$width}
				wrap='wrap'
				position='relative'
				padding={styles.padding}
				bdrRad='8px'
				justify={noOfCols > 1 ? 'space-between' : 'flex-start'}
				$direction={noOfCols > 1 ? 'row' : 'column'}
				$bg={styles.background}
				id={key}
				ref={contentRef}
				style={{ ...positionstyles }}>
				{renderHeading(noOfCols > 1 && '100%')}
				{contentData.map((colData, col) => (
					colData.length > 0 ? <Content ref={wrapperRef} direction={styles.direction} col={col} $width={styles.colWidth?.[col] || colWidth} key={col} content={colData} /> : renderTypes(wrapperRef)
				))}
			</ContentTypeWrap>
		</FlexDiv>
	);
};

export default memo(ContentTypes);
